import React, { useState } from "react";
import { licenseAPI } from "../../../utils/api";
import "./license-manager.css";

const LicenseManager = ({ licenseKey, studentName, onStatusChange }) => {
  const [loading, setLoading] = useState(false);
  const [licenseInfo, setLicenseInfo] = useState(null);
  const [error, setError] = useState("");
  const [showDetails, setShowDetails] = useState(false);

  const fetchLicenseInfo = async () => {
    try {
      setLoading(true);
      setError("");
      const response = await licenseAPI.getLicenseInfo(licenseKey);
      if (response.data.success) {
        setLicenseInfo(response.data.license);
        setShowDetails(true);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch license info");
    } finally {
      setLoading(false);
    }
  };

  const handleRevoke = async () => {
    if (
      !window.confirm(
        `Are you sure you want to revoke the license for ${studentName}?`
      )
    ) {
      return;
    }

    try {
      setLoading(true);
      setError("");
      const response = await licenseAPI.revokeLicense(licenseKey);
      if (response.data.success) {
        alert("License revoked successfully");
        if (onStatusChange) onStatusChange("revoked");
        fetchLicenseInfo();
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to revoke license");
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(licenseKey);
    alert("License key copied to clipboard!");
  };

  return (
    <div className="license-manager">
      <div className="license-key-display">
        <span className="license-key">{licenseKey}</span>
        <button
          onClick={copyToClipboard}
          className="copy-btn"
          title="Copy to clipboard"
        >
          📋
        </button>
      </div>

      <div className="license-actions">
        <button
          onClick={() => {
            if (!showDetails) {
              fetchLicenseInfo();
            } else {
              setShowDetails(false);
            }
          }}
          disabled={loading}
          className="info-btn"
        >
          {loading
            ? "Loading..."
            : showDetails
            ? "Hide Details"
            : "View Details"}
        </button>
        <button
          onClick={handleRevoke}
          disabled={loading}
          className="revoke-btn"
        >
          Revoke License
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {showDetails && licenseInfo && (
        <div className="license-details">
          <h4>License Details</h4>
          <div className="detail-row">
            <span className="label">Status:</span>
            <span className={`status status-${licenseInfo.status}`}>
              {licenseInfo.status}
            </span>
          </div>
          <div className="detail-row">
            <span className="label">Activations:</span>
            <span>
              {licenseInfo.activationCount} / {licenseInfo.maxActivations}
            </span>
          </div>
          {licenseInfo.activatedAt && (
            <div className="detail-row">
              <span className="label">Activated:</span>
              <span>{new Date(licenseInfo.activatedAt).toLocaleString()}</span>
            </div>
          )}
          {licenseInfo.lastValidated && (
            <div className="detail-row">
              <span className="label">Last Validated:</span>
              <span>
                {new Date(licenseInfo.lastValidated).toLocaleString()}
              </span>
            </div>
          )}
          {licenseInfo.revokedAt && (
            <div className="detail-row">
              <span className="label">Revoked:</span>
              <span>{new Date(licenseInfo.revokedAt).toLocaleString()}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LicenseManager;
